import React from 'react';
import { Divider } from '@material-ui/core';
import { TabRouteType } from '../../../shared/config/routesConfig';

import NavItem from './NavItem';

interface NavGroupProps {
  linkObj: TabRouteType;
  index: number;
  selectedIndex: number;
}
const NavGroup: React.FC<NavGroupProps> = ({ index, selectedIndex, linkObj }: NavGroupProps) => {
  const { name, link, icon } = linkObj;

  return (
    <div>
      <Divider />
      <div>
        <NavItem name={name} link={link} icon={icon} index={index} selectedIndex={selectedIndex} />
      </div>
    </div>
  );
};

export default NavGroup;
